export function faqToggle() {
    const $faqItem = $(".faq-item");
    const $faqTop = $(".faq-top");
    const $faqContent = $(".faq-content");
    $faqTop.on("click", function () {
        const $thisTop = $(this);
        const $thisDropdown = $thisTop.next($faqContent);
        $thisDropdown.slideToggle(400);
        $thisTop.closest($faqItem).toggleClass("active");
        $faqContent.not($thisDropdown).slideUp(500);
        $faqItem.not($thisTop.parent()).removeClass("active");
    });
    $($faqItem[0]).addClass("active");
    $($faqItem[0]).find($faqContent).slideDown(10);
}



// WEBPACK FOOTER //
// ./assets/js/modules/faqToggle.js